import React, { useState, useEffect, useRef } from 'react';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';

const CustomDropdown = ({
  options,
  value,
  onChange,
  name,
  placeholder,
  idKey,
  displayKey,
  disabled,
  getOptionDisabled // Add this prop
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value || '');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleToggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleSelectOption = (option) => {
    // Check if option is disabled using getOptionDisabled prop
    const isOptionDisabled = getOptionDisabled ? getOptionDisabled(option) : (option.disabled || false);

    if (!isOptionDisabled && !disabled) {
      setSelectedValue(option[idKey]);
      setIsOpen(false);
      onChange({ target: { name, value: option[idKey] } });
    }
  };

  const selectedOption = options.find(option => option[idKey] === selectedValue);
  
  //value scroller 
const textRef = useRef(null);
  const wrapperRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    const textEl = textRef.current;
    const wrapperEl = wrapperRef.current;

    if (textEl && wrapperEl) {
      const isOverflowing = textEl.scrollWidth > wrapperEl.clientWidth;
      setShouldScroll(isOverflowing);
    }
  }, [placeholder]);

  return (
    <div className={`custom-dropdown ${disabled ? 'disabled' : ''}`} ref={dropdownRef}>
      <div className="custom-dropdown__selected" onClick={handleToggleDropdown}>
        {selectedOption ? selectedOption[displayKey] : placeholder}
        <span className="custom-dropdown__caret">
          {isOpen ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
        </span>
      </div>
      {isOpen && (
        <div className="custom-dropdown__options" ref={textRef}>
          <div className="custom-dropdown__option" onClick={() => handleSelectOption({ [idKey]: '', [displayKey]: placeholder })}>
            {placeholder}
          </div>
          {options.map((option) => {
            // Determine if option is disabled
            const isOptionDisabled = getOptionDisabled ? getOptionDisabled(option) : (option.disabled || false);
            return (
              <div
                placeholder={'--Select--'}
                key={option[idKey]}
                className={`custom-dropdown__option ${isOptionDisabled ? 'disabled' : ''}`}
                onClick={() => handleSelectOption(option)}
              >
                {option[displayKey]}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;

